import { listComments } from "./comments";

// Per-user read state for case chats. Kept separately for each account (keyed by uid),
// so a lab and a designer track their own unread counts independently.
const key = (uid, caseId) => `dcc_read_${uid}_${caseId}`;

export function getLastRead(uid, caseId) {
  const v = localStorage.getItem(key(uid, caseId));
  return v ? Number(v) : 0;
}

export function setLastRead(uid, caseId, ts) {
  if (!uid || !caseId) return;
  localStorage.setItem(key(uid, caseId), String(ts || Date.now()));
}

// Number of chat messages in this case (for the currently selected designer) that are
// newer than the user's last read time and were written by the OTHER party.
export async function getUnreadCount(caseItem, uid) {
  const designerId = caseItem?.selectedDesignerId;
  if (!designerId) return 0;
  try {
    const list = await listComments(caseItem.id, designerId);
    const last = getLastRead(uid, caseItem.id);
    return list.filter((c) => (c._ts ?? 0) > last && c.authorId !== uid).length;
  } catch {
    return 0;
  }
}

// Compute unread counts for many cases at once -> { [caseId]: count }.
export async function getUnreadMap(cases, uid) {
  const entries = await Promise.all(
    (cases || []).map(async (c) => [c.id, await getUnreadCount(c, uid)])
  );
  return Object.fromEntries(entries);
}
